import apiInstance from '../services/ServiceApi';

const empresaApi = {

    getempresaDetail: async () => {
        try {
            const response = await apiInstance.get('/empresa/listdetail/');
            return response.data;
            } catch (error) {
            console.error("Error al obtener los usuarios:", error);
            throw error;
        }
    }

};

export default empresaApi;
